<template>
  <!-- GL Date -->
  <div v-if="!(isPermissionVat && isApprove && !isClaim)" :class="classLabel">
    <label class="form-label font-bold">GL Date:</label>
    <div>{{ glDate ? glDate : 'ไม่ระบุ' }}</div>
  </div>
  <div v-else>
    <label class="form-label font-bold">GL Date:</label>
    <div class="grid grid-cols-4 mb-2 lg:mb-2">
      <div class="col-span-3">
        <div class="p-fluid p-grid">
          <div class="p-field p-field-sm">
            <Calendar
              placeholder="2022-01-01"
              inputStyle="padding:0.5rem 0.75rem;"
              v-model="date"
              dateFormat="yy-mm-dd"
            />
          </div>
        </div>
      </div>
      <button type="button" @click="updateGlDate" class="btn btn-warning">
        อัพเดท
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, watch } from 'vue'
import { api } from '../utils/api'
import alert from '../helpers/alert'
import helpers from '../helpers'
// import dayjs from 'dayjs'

export default defineComponent({
  name: 'gl-date',
  props: {
    id: Number,
    url: {
      type: String,
      required: true
    },
    glDate: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    isPermissionVat: Boolean,
    isApprove: Boolean,
    isClaim: Boolean,
    classLabel: {
      type: String,
      default: () => 'flex flex-row lg:flex-col justify-between'
    }
  },
  setup(props) {
    const date = ref(props.glDate)
    // console.log('gl date: ', props.glDate, typeof props.glDate)
    const { dateFormat } = helpers
    const updateGlDate = async () => {
      await api
        .put(`${process.env.VUE_APP_API_URL}/${props.url}/${props.id}`, {
          gl_date: dateFormat(date.value)
        })
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error()
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    watch(
      () => props.glDate,
      newVal => {
        date.value = newVal
      }
    )

    return {
      ...toRefs(props),
      date,
      updateGlDate
    }
  }
})
</script>

<style scoped></style>
